/* UserAccount.js */

import React, { useCallback, useEffect, useState } from 'react';
import { Label, FormGroup, Row, Col } from 'reactstrap';
import WAM from '../../services/WAM';
import { useAuth } from '../../context/auth/AuthContext';
import Strings from '../../translations/Translations';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import Button1 from '../buttons/Button1';

export default function UserAccount () {
  const { authenticated, toggleLoading } = useAuth();
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState({ name: '', biography: '', website: '' });
  const { register, formState: { errors }, handleSubmit, setValue } = useForm();

  const onSubmit = useCallback(async ({ name, biography, website }) => {
    const requestData = {};
    requestData.username = authenticated.un;
    requestData.al = authenticated.al;

    let enabledToRequest = false;
    if (name !== undefined && name !== userData.name) {
      requestData.fullName = name;
      enabledToRequest = true;
    }
    if (biography !== undefined && biography !== userData.biography) {
      requestData.description = biography;
      enabledToRequest = true;
    }
    if (website !== undefined && website !== userData.website) {
      requestData.url = website;
      enabledToRequest = true;
    }

    if (enabledToRequest) {
      setLoading(true);
      try {
        const response = await WAM.setUserProfile(requestData);
  
        if (response.result === 'success') {
          toast.success(Strings('info_updated'));
        } else {
          const message = (response && response.error) ? response.error : Strings('error_on_update');
          toast.error(message);
        }
      } catch (err) {
        toast.error(Strings('general_error'));
      }
      setLoading(false);
    }
  }, [authenticated, setLoading, userData]);

  const getUserData = useCallback(async () => {
    const username = authenticated.un;
    const al = authenticated.al;
    toggleLoading(true);

    try {
      const response = await WAM.getUserProfile({username, al});
      if (response && response.result === 'success') {
        const data = WAM.listToJson(response.list);
        const userDataToSet = {};
        userDataToSet.name = (data.obj2) ? data.obj2 : '';
        userDataToSet.biography = (data.obj4) ? data.obj4 : '';
        userDataToSet.website = (data.obj6) ? data.obj6 : '';
        setValue('name', userDataToSet.name);
        setValue('biography', userDataToSet.biography);
        setValue('website', userDataToSet.website);
        setUserData(userDataToSet);
      } else {
        const message = (response && response.error) ? response.error : Strings('error_on_request');
        toast.error(message);
      }
    } catch (err) {
      toast.error(Strings('general_error'));
    }

    toggleLoading(false);
  }, [authenticated, toggleLoading, setUserData, setValue]);

  useEffect(() => { getUserData(); }, [getUserData]);

  return (
    <Row>
      <Col sm={12} className='mb-1'>
        <h2 className='h5'>
          {Strings('account_information')}
        </h2>
      </Col>

      <Col sm={12} className='mb-1'>
        <FormGroup>
          <Label className='pb-label-1'>{Strings('name')}</Label>
          <input
            className='form-control shadow pb-input-1'
            name='name'
            {...register('name', { required: true })}
          />
          {errors && errors.name && errors.name.type === 'required' && <p role='alert' className='text-danger txt-small-1'>{Strings('name_is_required')}</p>}
        </FormGroup>
      </Col>
      <Col sm={12} className='mb-1'>
        <FormGroup>
          <Label className='pb-label-1'>{Strings('biography')}</Label>
          <textarea
            className='form-control shadow pb-input-1'
            name='biography'
            {...register('biography')}
          />
        </FormGroup>
      </Col>
      <Col sm={12} className='mb-1'>
        <FormGroup>
          <Label className='pb-label-1'>{Strings('website')}</Label>
          <input
            className='form-control shadow pb-input-1'
            name='website'
            {...register('website')}
          />
        </FormGroup>
      </Col>
      <Col sm={12}>
        <Button1
          size='lg'
          className='pb-btn-1'
          onClick={handleSubmit(onSubmit)}
          loading={loading}
          disabled={loading}
        >
          {Strings('save')}
        </Button1>
      </Col>

    </Row>
  );
}
